
import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getExternalBrowserUrl } from '@/utils/browser-detection';
import { cn } from '@/lib/utils';

interface SocialBrowserBannerProps {
  className?: string;
}

const SocialBrowserBanner: React.FC<SocialBrowserBannerProps> = ({ className }) => {
  const externalUrl = getExternalBrowserUrl();
  
  const handleOpenInBrowser = () => {
    // Open the current page in the device's default browser
    window.open(externalUrl, '_blank');
  };
  
  return (
    <div className={cn(
      "fixed top-0 left-0 right-0 z-50 bg-primary px-4 py-2 shadow-lg animate-fade-in",
      className
    )}>
      <div className="flex items-center justify-between">
        <div className="text-sm text-primary-foreground font-medium">
          View the full experience
        </div>
        
        <Button 
          size="sm" 
          variant="secondary" 
          className="gap-1 text-xs" 
          onClick={handleOpenInBrowser}
        >
          <span>Open in browser</span>
          <ExternalLink className="h-3 w-3" />
        </Button>
      </div>
    </div>
  );
};

export default SocialBrowserBanner;
